import { AgGridReact } from "ag-grid-react";
import { useState, useRef, useEffect } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import GridComponent from "../../../../components/grid/gridComponent";
import PageTitle from "../../../shared/layout/pageTitle/pageTitle";
import GridTotalCountHeader from "../../../../components/grid/gridTotalCountHeader";
import { useAppDispatch } from "../../../../store/hooks";
import { getPartneredSummaryDetails, getCustomerPortalReportsFileAvailability } from "../../../../store/api/apiSlice";
import CurrencyConverter from "../../../shared/currencyConverter/CurrencyConverter";
import getFiles from "../../../shared/csvDownload/csvDownload";
import { useNavigate, useParams } from "react-router-dom";
import {
  COLUMN_CONFIG_REPORT_NAMES,
  formatDatePipe,
  formateIds,
  gridAlignment,
  visibleColumnNames,
} from "../../../../interface/comman.constant";
import { getTableFields } from "../../../../helpers/getTableFields";
import { useSelector } from "react-redux";
import { useUserSettings } from "../../../../helpers/hooks/useUserSettings";
import { showConfigColumns } from "../../../../helpers/getSortedVisibleCols";
import drugFileDownload from "../../../shared/csvDownload/drugFileDownload";
import { useAvailableReports } from "../../../../pages/admin/reporting/jobReports/useAvailableReports";
import { ReportsDropdown } from "../../../../components/reports/ReportsDropdown";
import { REPORT_META } from "../../../../pages/admin/reporting/jobReports/pageReports";
import { useCustomerPortalReportsFileAvailability } from "../../../../pages/admin/reporting/jobReports/useCustomerPortalReportsFileAvailability";
function PartneredSummary() {
  const gridRef = useRef<AgGridReact>(null);
  const myRef = useRef<any>();
  const dispatch = useAppDispatch();
  const [gridApi, setGridApi] = useState<any>(null);
  const userAccounts =
    useSelector((state: any) => state?.accounts?.chosenIds[0]) || [];
  const refreshPage =
    useSelector((state: any) => state?.accounts?.refreshPage) || false;

  const queryParams: any = useParams();
  const [returnableCreditSummaries, setReturnableCreditSummaries] =
    useState<any>(null);
  const [partneredSummaries, setPartneredSummaries] = useState<any>(null);
  const PartneredRow = localStorage.getItem("PartneredRow")
    ? JSON.parse(localStorage.getItem("PartneredRow") as any)
    : {};

    
  const { availability: partneredSummaryReportAvailability } =  useCustomerPortalReportsFileAvailability( queryParams.id, "partnered_customer_portal_reports_file_availability" );
  const { availability: nonPartneredSummaryReportAvailability } =  useCustomerPortalReportsFileAvailability( queryParams.id, "non_partnered_customer_portal_reports_file_availability" );
  const rawPartneredReports = useAvailableReports("partneredSummary", partneredSummaryReportAvailability);
  const rawNonPartneredReports = useAvailableReports("nonPartneredSummary", nonPartneredSummaryReportAvailability);
  const hasPartneredSummaries = !!partneredSummaries && Object.keys(partneredSummaries).length > 0;
  const partneredReports = hasPartneredSummaries ? rawPartneredReports : [];
  const nonPartneredReports = hasPartneredSummaries ? rawNonPartneredReports : [];
  const [selectedReportId, setSelectedReportId] = useState<string>("");
  const [selectedNonPartneredReportId, setSelectedNonPartneredReportId] = useState<string>("");
  
  const [gridData, setGridData] = useState({
    sortOrder: "",
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: [100, 200, 300],
    pageSize: 100,
    page: 1,
    globalSearch: "",
    totalCreditedERV: 0,
    totalOpenERV: 0,
    isForExcel: false,
    sortField: "",
    csvName: "PartneredSummary.csv",
    URL: "Reports/GetPartneredSummaryDetails",
    filterOptions: [],
    orderNumber: queryParams.id,
  });

  const columnItems = [
    {
      headerName: "Manufacturer",
      headerTooltip: "Manufacturer",
      tooltipShowDelay: 0,
      field: "manufacturer",
      tooltipField: "manufacturer",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
    {
      headerName: "Product",
      headerTooltip: "Product",
      tooltipShowDelay: 0,
      tooltipField: "product",
      field: "product",
      hide: false,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      comparator: customComparator,
    },
    {
      headerName: "NDC",
      headerTooltip: "NDC",
      tooltipShowDelay: 0,
      field: "ndc",
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
      type: gridAlignment.RIGHT,
    },
    {
      headerName: "DEA Class",
      headerTooltip: "DEA Class",
      tooltipShowDelay: 0,
      field: "deaClass",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
      type: gridAlignment.RIGHT,
    },
    {
      headerName: "Lot#",
      headerTooltip: "Lot#",
      tooltipShowDelay: 0,
      field: "lotNumber",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
    {
      headerName: "Expiration Date",
      headerTooltip: "Expiration Date",
      tooltipShowDelay: 0,
      field: "expirationDate",
      filter: "agDateColumnFilter",
      menuTabs: ["filterMenuTab"],
      filterParams: {
        suppressAndOrCondition: true,
        buttons: ["reset"],
        debounceMs: 1000,
      },
      hide: false,
      comparator: customComparator,
      valueFormatter: function (params: any) {
        return params.value !== null && params.value !== undefined
          ? formatDatePipe(params.value)
          : "";
      },
    },
    {
      headerName: "Full Quantity",
      field: "fullQuantity",
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
      type: gridAlignment.RIGHT,
    },
    {
      headerName: "Partial Quantity",
      field: "partialQuantity",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
    {
      headerName: "Credit Disposition",
      headerTooltip: "Credit Disposition",
      tooltipShowDelay: 0,
      field: "creditDisposition",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
    {
      headerName: "Value",
      headerTooltip: "Value",
      tooltipShowDelay: 0,
      field: "value",
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
      type: gridAlignment.RIGHT,
    },
    {
      headerName: "Non-Returnable Category",
      headerTooltip: "Non-Returnable Category",
      tooltipShowDelay: 0,
      field: "nonReturnableCategory",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
    {
      headerName: "Non-Returnable Reason",
      headerTooltip: "Non-Returnable Reason",
      tooltipShowDelay: 0,
      field: "nonReturnableReason",
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset"],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      menuTabs: ["filterMenuTab"],
      hide: false,
      comparator: customComparator,
    },
  ];

  const { id, dbColumnConfig } = useUserSettings(
    COLUMN_CONFIG_REPORT_NAMES?.PartneredWholesaler
  );
  const [colDefs, setColDefs] = useState(() =>
    showConfigColumns(columnItems, dbColumnConfig)
  );

  function customComparator() {
    return 0; ///means no comparing and no sorting client side
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if (gridData.globalSearch) {
      const getData = setTimeout(() => {
        partneredDetails();
      }, 2000);

      return () => clearTimeout(getData);
    } else {
      partneredDetails();
    }
  }, [
    gridData.page,
    gridData.pageSize,
    gridData.globalSearch,
    gridApi,
    refreshPage,
  ]);

  useEffect(() => {
    if (gridData.isForExcel === true) {
      getFiles(gridData, visibleColumnNames(colDefs), formateIds(userAccounts));
      updateGridData("isForExcel", false);
    }
  }, [gridData.isForExcel]);

  useEffect(() => {
    if (Object.keys(dbColumnConfig).length > 0)
      setColDefs(showConfigColumns(columnItems, dbColumnConfig));
  }, [dbColumnConfig]);

  const updateGridData = (k: any, v: any) =>
    setGridData((prev) => ({ ...prev, [k]: v }));

  const popupSave = (event: any, columnValues: any) => {
    event.preventDefault();

    setColDefs(columnValues);
    myRef?.current.handleClose();
  };
  // this function defination change after enterprise
  const partneredDetails = async () => {
    try {
      if (gridApi) {
        const dataSource = {
          getRows: (params: any) => {
            let data = {
              pageNumber:
                Math.floor(params.request.startRow / gridData.pageSize) + 1,
              pageSize: gridData.pageSize,
              sortField: params.request.sortModel?.[0]?.colId || "",
              sortDirection: params.request.sortModel?.[0]?.sort === "asc" ? 0 : 1,
              isForExcel: gridData.isForExcel,
              globalSearch: gridData.globalSearch,
              filterOptions: getTableFields(params.request.filterModel),
              CustomerIds: formateIds(userAccounts),
              orderNumber: queryParams.id,
              returnProgram: PartneredRow?.returnProgram,
            };
            updateGridData('returnProgram', PartneredRow?.returnProgram);
            updateGridData(
              "filterOptions",
              getTableFields(params.request.filterModel)
            );
            dispatch(getPartneredSummaryDetails(data)).then((result: any) => {
              if (result?.payload?.data?.orderLineDetails?.length === 0) {
                gridApi.showNoRowsOverlay();
                params.success({
                  rowData: [],
                  rowCount: 0,
                });
              } else {
                gridApi!.hideOverlay();
                params.success({
                  rowData: result?.payload?.data?.orderLineDetails,
                  rowCount: result?.payload?.data?.totalCount,
                });
              }
              updateGridData("totalRows", result?.payload?.data?.totalCount);
              setReturnableCreditSummaries(
                result?.payload?.data?.returnableCreditSummaries
              );
              setPartneredSummaries(result?.payload?.data?.partneredSummaries);
            });
          },
        };
        gridApi.setGridOption("serverSideDatasource", dataSource);
      }
    } catch (error) { }
  };

  const onSortChanged = ({
    api: { sortController },
  }: {
    api: { sortController: any };
  }): void => {
    const sortModel: any[] = sortController.getSortModel();
    if (sortModel.length > 0) {
      const { colId, sort } = sortModel[0];
      updateGridData("sortOrder", sort === "asc" ? 0 : 1);
      updateGridData("sortField", colId);
    }
  };

  const globalSearch = (e: any) => {
    updateGridData("globalSearch", e.target.value);
  };

  const onExport = (e: any) => {
    updateGridData("isForExcel", true);
  };

  

  const downloadReport = (reportId: string) => {

    const meta = REPORT_META[reportId as keyof typeof REPORT_META];
     const fileName = meta?.fileName
    ? `${queryParams.id} - ${meta.fileName}.pdf`
    : `${reportId}.pdf`;
  drugFileDownload(
    "Reports/GetCustomerPortalReportsFile",
     fileName, 
     queryParams.id,  
     formateIds(userAccounts),
     reportId,     
  );
};

    const handleReportSelect = (reportId: string) => {
    setSelectedReportId(reportId);
    downloadReport(reportId);
  };

  const handleNonPartneredReportSelect = (reportId: string) => {
    setSelectedNonPartneredReportId(reportId);
    downloadReport(reportId);
  };

  const onClearFilter = () => {
    gridApi!.setFilterModel(null);
    updateGridData("globalSearch", "");
  };
  const paginationChange = () => {
    if (gridApi) {
      updateGridData("pageSize", gridApi.paginationGetPageSize());
    }
  };
  return (
    <Container fluid>
      <PageTitle
        name={"Order History - " + queryParams.id}
        buttonName="Back"
        routePage="/reports/order-history"
      ></PageTitle>

      <div className="order-history-top">
        <div className="content_body">
          <Row>
            <Col xs={12} md={6}>
              <div className="highlight-section">
                <div className="header d-flex align-items-center">
                  <label className="me-4">Return Program: </label>
                  <span className="value">
                    {PartneredRow?.returnProgram || ""}
                  </span>
                </div>

                <div className="first-section d-flex flex-wrap gap-3 justify-content-between my-3">
                  <div className="d-flex flex-column">
                    <label>Pickup Date: </label>
                    <span className="value">
                      {partneredSummaries?.pickupDate}
                    </span>
                  </div>

                  <div className="d-flex flex-column">
                    <label>Received Date: </label>
                    <span className="value">
                      {partneredSummaries?.receivedDate}
                    </span>
                  </div>

                  <div className="d-flex flex-column">
                    <label>Process Date: </label>
                    <span className="value">
                      {partneredSummaries?.processDate}
                    </span>
                  </div>
                </div>

                <div className="d-flex flex-wrap flex-xl-nowrap p-3 gap-4 gap-xl-0">
                  <div className="d-flex flex-column min-width-20">
                    <label>Pallet Count</label>
                    <span className="value">
                      {partneredSummaries?.totalPalletCount}
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Box Count</label>
                    <span className="value">
                      {partneredSummaries?.totalBoxCount}
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Regular Waste</label>
                    <span className="value">
                      {partneredSummaries?.totalRegularWaste} lbs
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Hazardous Waste</label>
                    <span className="value">
                      {partneredSummaries?.totalHazardousWaste} lbs
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Controlled Waste</label>
                    <span className="value">
                      {partneredSummaries?.totalControlledWaste} lbs
                    </span>
                  </div>
                </div>

                <div className="d-flex flex-wrap flex-xl-nowrap p-3 gap-4 gap-xl-0">
                  <div className="d-flex flex-column min-width-20">
                    <label>Returnable ERV</label>
                    <span className="value">
                      {partneredSummaries?.totalReturnableERV}
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Overstock ERV </label>
                    <span className="value">
                      {partneredSummaries?.totalOverstockERV}
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Total ERV </label>
                    <span className="value">
                      {partneredSummaries?.totalERV}
                    </span>
                  </div>

                  <div className="d-flex flex-column min-width-20">
                    <label>Invoice </label>
                    <span className="value">
                      {partneredSummaries?.totalInvoice}
                    </span>
                  </div>

                  <div></div>
                </div>
              </div>
            </Col>
            {!(PartneredRow?.returnProgram === "Non-Partnered Wholesaler") ? (
              <Col xs={12} md={6}>
                <div className="detail-table mt-3 mt-md-0">
                  <Table responsive>
                    <thead className="sticky-top">
                      <tr>
                        <th>Returnable Credit Summary</th>
                        <th>ERV</th>
                        <th>ARV</th>
                        <th>Outstanding ERV</th>
                      </tr>
                    </thead>
                    <tbody>
                      {returnableCreditSummaries &&
                        returnableCreditSummaries.length > 0 &&
                        returnableCreditSummaries.map((r: any) => (
                          <tr>
                            <td>{r.creditStatus}</td>
                            <td>{r.erv}</td>
                            <td>{r.creditAmount}</td>
                            <td>{r.outstandingERV}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>

                  <div className="pdf-listing-wrapper mt-3">
                    <div className="pdf-listing">
                      <ul>
                        <li>
                          { <ReportsDropdown
                            reports={partneredReports}
                            value={selectedReportId}
                            onChange={handleReportSelect}
                            className="form-select w-auto"
                          /> }
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            ) : (
              <Col xs={12} md={6}>
                <div className="pdf-listing-wrapper">
                  <div className="pdf-listing">
                    <h3> PDF Reports</h3>
                    <ul>
                      <li>
                        <ReportsDropdown
                          reports={nonPartneredReports}
                          value={selectedNonPartneredReportId}
                          onChange={handleNonPartneredReportSelect}
                          className="form-select w-auto"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>

      <div className="content_body">
        <GridComponent
          dbUserReportId={id}
          dbReportName={COLUMN_CONFIG_REPORT_NAMES?.PartneredWholesaler}
          dbColumnConfig={dbColumnConfig}
          defaultColumns={columnItems}
          ref={myRef}
          gridRef={gridRef}
          rowData={gridData.rows}
          colDefs={colDefs}
          onGridReady={onGridReady}
          popupSave={popupSave}
          paginationPageSize={gridData.pageSize}
          paginationPageSizeSelector={gridData.rowsPerPageOptions}
          sortChange={onSortChanged}
          globalSearch={globalSearch}
          onExport={onExport}
          gridData={gridData}
          setGridData={setGridData}
          onClearFilter={onClearFilter}
          paginationChange={paginationChange}
          autoSizeStrategy={{
            type: "fitCellContents",
            colIds: [
              "orderNumber",
              "pickupDate",
              "processDate",
              "boxCount",
              "palletCount",
              "regularWaste",
              "hazardousWaste",
              "controlledWaste",
              "returnableERV",
              "overstockERV",
              "totalERV",
              "invoice",
              "unrecoveredCredits",
              "disqualifiedCredits",
              "serviceFeeRate",
              "serviceFeeRefund",
              "netInvoice",
            ],
          }}
        />
      </div>
    </Container>
  );
}
export default PartneredSummary;
